import anime from 'animejs/lib/anime.es.js'; // fonctionne avec v3

export default class TitleAnimator {
    constructor(selector) {
        this.element = document.querySelector(selector);
        if (!this.element) return;
        this.wrapWords();
        this.animate();
    }

wrapWords() {
    const lines = this.element.querySelectorAll('span'); // Chaque ligne
    this.element.innerHTML = ''; // On va reconstruire

    lines.forEach(line => {
        const words = line.textContent.trim().split(' ');
        const lineWrapper = document.createElement('div');
        lineWrapper.classList.add('line');

        words.forEach(word => {
            const letters = word.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");
            lineWrapper.innerHTML += `<span class="word">${letters}</span>`;
        });

        this.element.appendChild(lineWrapper);
    });
}

    animate() {
        anime.timeline({ loop: false })
            .add({
                targets: '.animated-title .letter',
                translateY: [50, 0],
                opacity: [0, 1],
                easing: "easeOutExpo",
                duration: 1500,
                delay: (el, i) => 30 * i
            });
    }
}